// extracted by mini-css-extract-plugin
module.exports = {"header":"Modal_header__1J2W3","title":"Modal_title__1YZoR","body":"Modal_body__12Y5K"};